document.addEventListener("DOMContentLoaded", function () {
  // Reference the div containing the dropdown menu
  const homeDropdown = document.getElementById("home-dropdown");

  // Function to close all open <details> elements
  function closeAllDetails() {
    const openDetails = homeDropdown.querySelectorAll("details[open]");
    openDetails.forEach(detail => {
      detail.removeAttribute("open");
    });
  }

  // Listen for clicks anywhere in the document
  document.addEventListener("click", function (event) {
    // Check if the click was outside the homeDropdown div
    if (homeDropdown && !homeDropdown.contains(event.target)) {
      closeAllDetails();
    }
  });

  // Optional: Prevent closing when clicking inside a summary element to allow toggling
  homeDropdown.addEventListener("click", function (event) {
    if (event.target.tagName.toLowerCase() === "summary") {
      event.stopPropagation(); // Stop click propagation to avoid immediate closing
    }
  });
});



var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// Home page slider

$('.abz_product_ul').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  vertical: true,
  verticalSwiping: true,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        vertical: false,
        verticalSwiping: false,
      }
    }
  ]
});


$(document).ready(function(){
    // Hide all tab contents first
    $('.tab-content').hide();

    // Show the first tab content by default
    $('.tab-content[data-tab="1"]').show();
    $('.abz_select span[value="1"]').addClass('active');

    // Handle span click events
    $('.abz_select span').click(function () {
        // Remove active class from all span elements
        $('.abz_select span').removeClass('active');
        
        // Add active class to the clicked span
        $(this).addClass('active');

        // Hide all tab contents
        $('.tab-content').hide();

        // Show the corresponding tab content
        var tabId = $(this).attr('value');
        $('.tab-content[data-tab="' + tabId + '"]').show();
    });
});


// PDP payment popup

$(document).ready(function (){
  $(".open").click(function (){
    $(".pop-outer").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".pop-outer").fadeOut("slow");
  });
});



$(document).ready(function (){
  $(".open-new").click(function (){
    $(".pop-outer-new").fadeIn("slow");
  });
  $(".close-new").click(function (){
    $(".pop-outer-new").fadeOut("slow");
  });
});



$(document).ready(function() {
    $('.pop-pdp.open, .pop-pdp.open-new').click(function() {
      $('body').addClass('custom-class');
    });

    $('.pop-pdp.close, .pop-pdp.close-new').click(function() {
      $('body').removeClass('custom-class');
    });
  });


// PDP payment popup End


// Footer


window.addEventListener('DOMContentLoaded', () => {
if (window.matchMedia('(min-width: 750px)').matches) {
return
}

const handleCollapse = (heading) => {
if (heading.classList.contains('block-collapsed')) {
heading.classList.remove('block-collapsed')
heading.setAttribute('aria-expanded', 'true')
} else {
heading.classList.add('block-collapsed')
heading.setAttribute('aria-expanded', 'false')
}
}

document.querySelectorAll('.footer-title-abz').forEach((heading, index) => {
heading.classList.add('block-collapsed')
heading.setAttribute('role', 'button')
heading.setAttribute('aria-expanded', 'false')
heading.setAttribute('tabindex', '0')

heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`)
heading.setAttribute('aria-controls', `footer-block-index-${index}`)

heading.addEventListener('click', () => { handleCollapse(heading) })
heading.addEventListener('keypress', () => { handleCollapse(heading) })
})

})

// Collection Page


// $('.collection-page-list-product').slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   arrows: false,
//   dots: false,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   responsive: [
//     {
//       breakpoint: 1000,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       }
//     }
//   ]
// });


$(document).ready(function(){
  var $slider = $('.collection-page-list-product');
  var itemCount = $slider.children().length;
  var windowWidth = $(window).width();  // Get the window width

  // For window width 750px or larger
  if (windowWidth >= 750) {
    if (itemCount >= 3.5) {
      // Initialize slider if there are 4 or more items
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 3, // Show 4 items on larger screens
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          autoplay: false,
          autoplaySpeed: 3000
        });
      }
    } else {
      // Unslick the slider if there are fewer than 4 items
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }

  // For window width 749px or smaller (always initialize slider regardless of item count)
  } else if (windowWidth <= 749) {
    // Always initialize the slider on small screens, no item count check needed
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 2, // Show 2 items on smaller screens
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000
      });
    }
  }
});



// abz-custom-search start
// class AbzCustomSearch extends HTMLElement {
//   constructor() {
//     super();

//     this.submitBtn = this.querySelector('a.search');
//     this.input1 = this.querySelector('input');
//     this.input2 = document.querySelector('search-drawer input[type="search"]');
//     this.searchForm = this.input2 ? this.input2.form : null;
//     if(!this.input1 || !this.input2 || !this.submitBtn) return;

//     this.syncInputs();
//     this.setupSubmit();
//     this.setupEnterKey();
//   }

//   syncInputs() {
//     // Sync input2 to input1 without triggering change event
//     this.input2.addEventListener('input', () => {
//       this.input1.value = this.input2.value;
//     });
//   }

//   setupSubmit() {
//     this.submitBtn.addEventListener('click', (e) => {
//       this.input2.value = this.input1.value;
//       // Trigger change event on input2
//       const event = new Event('input', { bubbles: true });
//       this.input2.dispatchEvent(event);
//     });
//   }

//   setupEnterKey() {
//     this.input1.addEventListener('keypress', (e) => {
//       if (e.key === 'Enter' && this.input1.value.trim() !== '') {
//         e.preventDefault();
//         this.submitBtn.click();
//       }
//     });
//   }
// }

// customElements.define('abz-custom-search', AbzCustomSearch);

// function setHeaderTop() {
//   const header = document.querySelector('header');
//   const main = document.querySelector('main#main');
//   if (window.scrollY > 0) {
//     header.classList.add('top_zero_fixed');
//     main.style.paddingTop = 'var(--header-height) !important';
//   } else {
//     header.classList.remove('top_zero_fixed');
//     const headerHeight = `calc(var(--header-height) * 0) !important`;
//     main.style.paddingTop = headerHeight;
//   }
// }

// window.addEventListener('scroll', setHeaderTop);
// abz-custom-search END